module.exports = __webpack_public_path__ + "img/p-13-3.e10e8883.jpg";